import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function AdminDashboard() {
  const { user, isAdmin } = useAuth();
  const [stats, setStats] = useState({ articles: 0, users: 0, views: 0 });

  useEffect(() => {
    // Fetch stats from API
    fetch('https://victor-web.leerheld.workers.dev/admin/stats')
      .then(r => r.json())
      .then(data => setStats(data))
      .catch(() => setStats({ articles: 42, users: 156, views: 12580 }));
  }, []);

  if (!isAdmin) return <div className="container mx-auto px-4 py-20"><h1 className="text-3xl font-bold text-red-600">Toegang geweigerd</h1></div>;

  return (
    <div className="container mx-auto px-4 py-16">
      <h1 className="text-4xl font-bold mb-8">Admin Dashboard</h1>
      <div className="grid md:grid-cols-3 gap-6 mb-12">
        <div className="bg-white rounded-xl shadow-lg p-6">
          <div className="text-4xl font-bold text-blue-600">{stats.articles}</div>
          <div className="text-gray-600">Artikelen</div>
        </div>
        <div className="bg-white rounded-xl shadow-lg p-6">
          <div className="text-4xl font-bold text-green-600">{stats.users}</div>
          <div className="text-gray-600">Gebruikers</div>
        </div>
        <div className="bg-white rounded-xl shadow-lg p-6">
          <div className="text-4xl font-bold text-purple-600">{stats.views.toLocaleString()}</div>
          <div className="text-gray-600">Pagina views</div>
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-6">
        <Link to="/admin/nieuws" className="bg-gradient-to-r from-red-600 to-red-700 text-white rounded-xl shadow-lg p-8 hover:shadow-2xl transition">
          <h2 className="text-2xl font-bold mb-2">Nieuws beheren</h2>
          <p className="opacity-90">Artikelen toevoegen, bewerken en verwijderen</p>
        </Link>
        <Link to="/admin/users" className="bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl shadow-lg p-8 hover:shadow-2xl transition">
          <h2 className="text-2xl font-bold mb-2">Gebruikers beheren</h2>
          <p className="opacity-90">Gebruikersaccounts en rollen beheren</p>
        </Link>
      </div>
    </div>
  );
}
